//
//
//
//
//
//
//
//
//
//
//
//
//
//

import userInfo from './components/userInfo';
import userRegion from './components/userRegion';
import cardsData from '@/components/cards/index';
import { userTotalData } from '@/api/statistic';
import { checkPermi } from '@/utils/permission'; // 权限判断函数
export default {
  components: {
    userInfo: userInfo,
    // wechetInfo,
    userRegion: userRegion,
    cardsData: cardsData
  },
  data: function data() {
    return {
      list: [],
      formInline: {
        channel_type: '',
        data: ''
      }
    };
  },
  mounted: function mounted() {
    this.getStatistics();
  },
  methods: {
    checkPermi: checkPermi,
    // 统计
    getStatistics: function getStatistics() {
      var _this = this;
      userTotalData().then(function (res) {
        _this.list = [{
          name: '累计用户数',
          icon: 'iconleijiyonghushu',
          count: res.userNum,
          class: 'one',
          color: '#1890FF'
        }, {
          name: '累计充值人数',
          icon: 'iconyonghu',
          count: res.rechargePeopleNum,
          class: 'two',
          color: '#A277FF'
        }, {
          name: '累计充值金额',
          icon: 'iconchongzhijine',
          count: res.rechargeTotalAmount,
          class: 'three',
          color: '#EF9C20'
        }, {
          name: '累计消费金额',
          icon: 'iconzhichujine1',
          count: res.consumptionAmount,
          class: 'four',
          color: '#1BBE6B'
        }];
      });
    }
  }
};